function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module enter/shiftentercommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import { getCopyOnEnterAttributes } from './utils';
/**
 * ShiftEnter command. It is used by the {@link module:enter/shiftenter~ShiftEnter ShiftEnter feature} to handle
 * the <kbd>Shift</kbd>+<kbd>Enter</kbd> keystroke.
 *
 * @extends module:core/command~Command
 */

var ShiftEnterCommand = /*#__PURE__*/function (_Command) {
  _inherits(ShiftEnterCommand, _Command);

  var _super = _createSuper(ShiftEnterCommand);

  function ShiftEnterCommand() {
    _classCallCheck(this, ShiftEnterCommand);

    return _super.apply(this, arguments);
  }

  _createClass(ShiftEnterCommand, [{
    key: "execute",
    value:
    /**
     * @inheritDoc
     */
    function execute() {
      var _this = this;

      var model = this.editor.model;
      var doc = model.document;
      model.change(function (writer) {
        softBreakAction(model, writer, doc.selection);

        _this.fire('afterExecute', {
          writer: writer
        });
      });
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var model = this.editor.model;
      var doc = model.document;
      this.isEnabled = isEnabled(model.schema, doc.selection);
    }
  }]);

  return ShiftEnterCommand;
}(Command); // Checks whether the ShiftEnter command should be enabled in the specified selection.
//
// @param {module:engine/model/schema~Schema} schema
// @param {module:engine/model/selection~Selection|module:engine/model/documentselection~DocumentSelection} selection


export { ShiftEnterCommand as default };

function isEnabled(schema, selection) {
  // At this moment it is okay to support single range selections only.
  // But in the future we may need to change that.
  if (selection.rangeCount > 1) {
    return false;
  }

  var anchorPos = selection.anchor; // Check whether the break element can be inserted in the current selection anchor.

  if (!anchorPos || !schema.checkChild(anchorPos, 'softBreak')) {
    return false;
  }

  var range = selection.getFirstRange();
  var startElement = range.start.parent;
  var endElement = range.end.parent; // Do not modify the content if selection is cross-limit elements.

  if ((isInsideLimitElement(startElement, schema) || isInsideLimitElement(endElement, schema)) && startElement !== endElement) {
    return false;
  }

  return true;
} // Creates a break in the way that the <kbd>Shift</kbd>+<kbd>Enter</kbd> keystroke is expected to work.
//
// @param {module:engine/model~Model} model
// @param {module:engine/model/writer~Writer} writer
// @param {module:engine/model/selection~Selection|module:engine/model/documentselection~DocumentSelection} selection
// Selection on which the action should be performed.


function softBreakAction(model, writer, selection) {
  var isSelectionEmpty = selection.isCollapsed;
  var range = selection.getFirstRange();
  var startElement = range.start.parent;
  var endElement = range.end.parent;
  var isContainedWithinOneElement = startElement == endElement;

  if (isSelectionEmpty) {
    var attributesToCopy = getCopyOnEnterAttributes(model.schema, selection.getAttributes());
    insertBreak(model, writer, range.end);
    writer.removeSelectionAttribute(selection.getAttributeKeys());
    writer.setSelectionAttribute(attributesToCopy);
  } else {
    var leaveUnmerged = !(range.start.isAtStart && range.end.isAtEnd);
    model.deleteContent(selection, {
      leaveUnmerged: leaveUnmerged
    }); // Selection within one element:
    //
    // <h>x[xx]x</h>		-> <h>x^x</h>			-> <h>x<br>^x</h>

    if (isContainedWithinOneElement) {
      insertBreak(model, writer, selection.focus);
    } // Selection over multiple elements.
    //
    // <h>x[x</h><p>y]y<p>	-> <h>x^</h><p>y</p>	-> <h>x</h><p>^y</p>
    //
    // We chose not to insert a line break in this case because:
    //
    // * it's not a very common scenario,
    // * it actually surprised me when I saw the "expected behavior" in real life.
    //
    // It's ok if the user will need to be more specific where they want the <br> to be inserted.
    else {
        // Move the selection to the 2nd element (last step of the example above).
        if (leaveUnmerged) {
          writer.setSelection(endElement, 0);
        }
      }
  }
}

function insertBreak(model, writer, position) {
  var breakLineElement = writer.createElement('softBreak');
  model.insertContent(breakLineElement, position);
  writer.setSelection(breakLineElement, 'after');
} // Checks whether the specified `element` is a child of the limit element.
//
// Checking whether the `<p>` element is inside a limit element:
//   - <$root><p>Text.</p></$root> => false
//   - <$root><limitElement><p>Text</p></limitElement></$root> => true
//
// @param {module:engine/model/element~Element} element
// @param {module:engine/schema~Schema} schema
// @returns {Boolean}


function isInsideLimitElement(element, schema) {
  // `$root` is a limit element but in this case is an invalid element.
  if (element.is('rootElement')) {
    return false;
  }

  return schema.isLimit(element) || isInsideLimitElement(element.parent, schema);
}